<template>
  <div
    class="w-100 mb10 searchpanel"
    data-testid="searchPanel"
  >
    <div>
      <label for="search" class="visually-hidden">
        {{ $t('Search') }}
      </label>
      <div class="search-input-group flex">
        <input
          ref="search"
          id="search"
          v-model="search"
          @input="makeSearch"
          @blur="$v.search.$touch()"
          @keyup.enter="toggleQueryFilter"
          class="search-panel-input bg-cl-light-white"
          :placeholder="$t('search by name, color or designer')"
          type="text"
        >
        <!-- <i class="icon-microphone voice-search-icon col-xs-1" :class="{'cl-main': btnStop}" @click="startRecording" /> -->
        <i class="icon-search search-icon" />
        <!-- <i class="icon-close ipad-icon" @click="closeSearchpanel" /> -->
      </div>
      <span class="cl-error notification px15" v-if="getNoResultsMessage !== ''">{{ getNoResultsMessage }}</span>
    </div>
    <!-- <transition name="fade">
      <div class="container search-layer search-layer-voice flex bg-cl-primary middle-xs" v-show="btnStop">
        <div class="flex flex-col middle-xs">
          <div class="lds-facebook">
            <div />
            <div />
            <div />
            <div />
          </div>
          <b class="h5 cl-black">{{ $t('Speak now') }}</b>
        </div>
        <div class="listening">
          <p class="listening--text-result m0 pl5 cl-black">
            {{ textResult }}
          </p>
          <i class="cancel icon-close" @click="stopRecording" />
        </div>
      </div>
    </transition> -->
    <transition name="fade">
      <div class="container search-layer bg-cl-light-white" v-show="search.length && visibleProducts.length">
        <i class="icon-close close-icon" @click="closeSearchpanel" />
        <button-full
          v-show="search.length && visibleProducts.length"
          @click.native="toggleQueryFilter"
          class="button__show-all fs16 bg-cl-black shadow-1"
        >
          {{ $t('Show all results') }}
        </button-full>
        <div class="categories">
          <category-panel :categories="categories" v-model="selectedCategoryIds" />
        </div>
        <div class="product-listing row mt10">
          <div class="flex col-xs-6 my10 center-xs" v-for="(product, index) in visibleProducts" :key="product.id">
            <product-tile
              class="update-add-to-cart"
              :product="product"
              :position="index"
              list="search"
              @click.native="closeSearchpanel"
            />
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import { formatCategoryLink } from '@vue-storefront/core/modules/url/helpers'
import SearchPanel from '@vue-storefront/core/compatibility/components/blocks/SearchPanel/SearchPanel'
import ProductTile from 'theme/components/core/ProductTile'
import VueOfflineMixin from 'vue-offline/mixin'
import CategoryPanel from 'theme/components/core/blocks/Category/CategoryPanel'
import ButtonFull from 'theme/components/theme/ButtonFull.vue'
import { minLength } from 'vuelidate/lib/validators'
import { mapGetters } from 'vuex'
import config from 'config'

export default {
  mixins: [SearchPanel, VueOfflineMixin],
  validations: {
    search: {
      minLength: minLength(3)
    }
  },
  components: {
    ProductTile,
    CategoryPanel,
    ButtonFull
  },
  data () {
    return {
      search: '',
      selectedCategoryIds: [],
      textResult: '',
      finalResult: '',
      btnStop: false
    }
  },
  computed: {
    ...mapGetters('category-next', ['getMenuCategories']),
    isQueryFilterActive () {
      return this.$store.state.ui.isQueryFilterActive
    },
    isToggleSearch () {
      return (((this.visibleProducts.length && this.categories.length > 1) && this.search.length > 1) && this.toogleSearchModal)
    },
    visibleProducts () {
      const productList = this.products || []
      if (this.selectedCategoryIds.length) {
        return productList.filter(product => product.category_ids.some(categoryId => {
          const catId = parseInt(categoryId)
          return this.selectedCategoryIds.includes(catId)
        }))
      }
      return productList
    },
    getMainCategory () {
      return this.getMenuCategories.find(cat => cat.id === config.server.categoryIdsMap.mainCategoryId)
    },
    categories () {
      const categoriesMap = {}
      this.products.forEach(product => {
        if (product.category) {
          return [...product.category].forEach(category => {
            categoriesMap[category.category_id] = category
          })
        }
      })
      return Object.keys(categoriesMap).map(categoryId => categoriesMap[categoryId])
    },
    getNoResultsMessage () {
      let msg = ''
      if (!this.$v.search.minLength) {
        msg = 'Searched term should consist of at least 3 characters.'
      } else if (this.emptyResults) {
        msg = 'No results were found.'
      }
      return this.$t(msg)
    }
  },
  methods: {
    categoryLink (category) {
      return formatCategoryLink(category)
    },
    toggleQueryFilter () {
      if (this.getNoResultsMessage === '') {
        if (this.getMainCategory) {
          this.$router.push({ path: this.categoryLink(this.getMainCategory), query: { query: this.search } })
          this.search = ''
          this.$store.commit('ui/setSidebar', false)
        }
      }
    },
    closeSearchpanel () {
      this.search = ''
      this.products = []
      let body = document.getElementsByTagName('body')[0]
      body.classList.remove('iphone-scroll')
    }
  },
  watch: {
    categories () {
      this.selectedCategoryIds = []
    }
  }
}
</script>

<style lang="scss" scoped>
@import "~theme/css/animations/transitions";
@import "~theme/css/variables/grid";
@import "~theme/css/variables/typography";
@import '~theme/css/variables/colors';
@import '~theme/css/helpers/functions/color';
$color-main: color(main);
$black: color(black);
.lds-facebook {
  display: inline-block;
  position: relative;
  width: 35px;
  height: 15px;
  margin-bottom: 30px;
}
.lds-facebook div {
  display: inline-block;
  position: absolute;
  left: 6px;
  width: 13px;
  background: $color-main;
  height: 20px;
  width: 5px;
  opacity: 0.5;
  animation: lds-facebook 1s ease infinite;
}
.lds-facebook div:nth-child(1) {
  left: 0px;
  animation-delay: -0.36s;
}
.lds-facebook div:nth-child(2) {
  left: 10px;
  animation-delay: -0.24s;
}
.lds-facebook div:nth-child(3) {
  left: 20px;
  animation-delay: -0.12s;
}
.lds-facebook div:nth-child(4) {
  left: 30px;
  animation-delay: 0;
}
@keyframes lds-facebook {
  0% {
    top: 0;
    opacity: 0.5;
  }
  50% {
    top: 10px;
    opacity: 1;
  }
  100% {
    top: 0;
    opacity: 0.5;
  }
}
.cancel {
  position: absolute;
  right: 15px;
  top: 10px;
  font-size: 18px;
}
.search-input-group {
    position: relative;
}
.close-icon-sidebar {
  position: absolute;
  top: -15px;
  font-size: 21px;
  right: 18px;
}
.voice-search-icon {
    position: absolute;
    top: 50%;
    right: 20%;
    font-size: 26px;
    transform: translate(0, -50%);
}
.search-icon {
    position: absolute;
    top: 50%;
    left: 0px;
    transform: translate(0, -50%);
}
.search-panel-input {
  &::-webkit-input-placeholder {
    color: #000;
  }
    position: relative;
    outline: none;
    border: none;
    width: 100%;
    font-size: 12px;
    padding-left: 45px;
    vertical-align: middle;
    font-family: 'Poppins';
    height: 44px;
}
.notification {
  font-size: 12px;
  width: 100%;
  padding: 0;
  text-align: center;
  left: 0;
}

.searchpanel {
  .search-layer {
    position: relative;
    margin-top: 10px;
    overflow-y: auto;
    z-index: 3;
    width: 100%;
    padding-top: 10px;
    max-height: calc(100vh - 100px);
    height: calc(100vh - 100px);
    max-width: 100%;
  }
  .search-layer-voice {
    z-index: 10 !important;
    top: 75px !important;
    border-radius: 25px;
    padding-bottom: 10px;
  }
  .close-icon-row {
    display: flex;
    justify-content: flex-end;
  }

  .container {
    padding-left: 20px;
    padding-right: 20px;

    @media #{$media-xs} {
      padding-left: 10px;
      padding-right: 10px;
    }
  }

  .row {
    margin-left: - map-get($grid-gutter-widths, lg) / 2;
    margin-right: - map-get($grid-gutter-widths, lg) / 2;

    @media #{$media-xs} {
      margin-right: - map-get($grid-gutter-widths, xs) / 2;
      margin-left: - map-get($grid-gutter-widths, xs) / 2;
    }
  }

  .col-md-12 {
    padding-left: map-get($grid-gutter-widths, lg) / 2;
    padding-right: map-get($grid-gutter-widths, lg) / 2;

    @media #{$media-xs} {
      padding-left: map-get($grid-gutter-widths, xs) / 2;
      padding-right: map-get($grid-gutter-widths, xs) / 2;
    }
  }

  .product-listing {
    padding-bottom: 160px;
  }
  .ipad-icon {
    display: none;
    @media only screen and (min-device-width : 768px) and (max-device-width : 1024px) {
      position: absolute;
      display: inline-block;
      top: 50%;
      right: 4%;
      font-size: 35px;
      transform: translate(0, -50%);
    }
  }
}

.button__show-all {
    position: fixed;
    left: 0;
    bottom: 15px;
    right: 0;
    z-index: 5;
    background-color: $color-main;
    font-weight: 500;
    padding: 10px 15px;
    width: 90%;
    max-width: 400px;
    margin: 0 auto;
}
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s;
}
.fade-in {
  &-left-enter-active,
  &-right-enter-active{
    transition: all 0.3s cubic-bezier(0.4, 0.0, 0.2, 1);
  }

  &-left-leave-active,
  &-right-leave-active {
    transition: all 0.3s cubic-bezier(0.4, 0.0, 1, 1);
  }
}
::-webkit-scrollbar {
    width: 5px;
}
::-webkit-scrollbar-track {
  background-color: transparent;
}
::-webkit-scrollbar-thumb {
  background-color: $black;
  border-radius: 15px;
  border: none;
}
.close-icon {
  position: absolute;
  right: 15px;
  top: 3px;
}
@media screen and (max-width: 767px) and (-webkit-min-device-pixel-ratio:0) {
  #search {
    font-size: 16px;
  }
}
</style>
